  <div class="destination-container" [ngClass]="darkMode ?'destination-background-dark' : 'destination-background-light'">
    <app-where-to-card [setFocus]="true"></app-where-to-card>
  </div>
  <app-destination-results *ngIf="!validating"
                           [screenHeight]="screenHeight"
                           [confirmDestination]="confirmDestination">
  </app-destination-results>
  <mat-spinner style="margin: 12px auto;" [diameter]="50" *ngIf="validating"></mat-spinner>
